module.exports = __webpack_public_path__ + "img/sui-generis.82054ac8.png";